import React from 'react'
import styled from 'styled-components'
import { Container, Kicker, MOBILE } from '../CustomLanding.styled'
import AboutPhoto from '../Assets/about-photo.jpg'
import { about, colors } from '../content'

const AboutInstructor: React.FC = () => (
	<Section id="about">
		<Split>
			<PhotoCol>
				<PhotoFrame role="img" aria-label={about.photoCaption} />
				<Facts>
					{about.facts.map(fact => (
						<Fact key={fact}>
							<FactDot />
							{fact}
						</Fact>
					))}
				</Facts>
			</PhotoCol>
			<TextCol>
				<Kicker>{about.kicker}</Kicker>
				<Title>{about.title}</Title>
				<P>
					مستر <strong>إبراهيم فريد</strong> مدرس لغة إنجليزية للمرحلة الثانوية، خريج{' '}
					<strong>كلية الآداب – قسم اللغة الإنجليزية – جامعة القاهرة</strong>، وبيشتغل في مجال التدريس من أكتر من{' '}
					<strong>25 سنة</strong>.
				</P>
				<P>{about.p2}</P>
				<P>{about.p3}</P>
			</TextCol>
		</Split>
	</Section>
)

export default AboutInstructor

const Section = styled.section`
	background: ${colors.paper};
	padding: 64px 0;
	${MOBILE} {
		padding: 8px 0 40px;
	}
`

const Split = styled(Container)`
	display: flex;
	flex-wrap: wrap;
	gap: 40px 56px;
	/* centered so the smaller photo sits balanced against the bio text */
	align-items: center;
	${MOBILE} {
		display: block;
	}
`

const PhotoCol = styled.div`
	flex: 0 1 300px;
	min-width: 0;
	max-width: 300px;
	${MOBILE} {
		max-width: none;
		margin-bottom: 24px;
	}
`

/* Square source shown at its own ratio on desktop (nothing cropped); the
   mobile 4:3 window stays anchored to the top so the head is never clipped. */
const PhotoFrame = styled.div`
	aspect-ratio: 1 / 1;
	border-radius: 24px;
	overflow: hidden;
	border: 1px solid rgba(22, 58, 132, 0.16);
	background-color: #e9ebf1;
	background-image: url(${AboutPhoto});
	background-size: cover;
	background-position: center;
	${MOBILE} {
		aspect-ratio: 4 / 3;
		border-radius: 20px;
		background-position: center top;
	}
`

const Facts = styled.div`
	margin-top: 20px;
	display: flex;
	flex-direction: column;
	gap: 8px;
	font-size: 14px;
	color: ${colors.muted};
	line-height: 1.7;
	${MOBILE} {
		display: none;
	}
`

const Fact = styled.div`
	display: flex;
	gap: 10px;
	align-items: baseline;
`

const FactDot = styled.span`
	width: 6px;
	height: 6px;
	border-radius: 999px;
	background: ${colors.blue};
	flex: 0 0 auto;
	transform: translateY(-2px);
`

const TextCol = styled.div`
	flex: 1.5 1 420px;
	min-width: 0;
`

const Title = styled.h2`
	font-weight: 700;
	font-size: clamp(24px, 2.2vw, 34px);
	line-height: 1.35;
	color: ${colors.navy};
	margin: 0 0 32px;
	${MOBILE} {
		font-size: 28px;
		line-height: 1.4;
		margin-bottom: 20px;
	}
`

const P = styled.p`
	font-size: 17px;
	line-height: 2.05;
	color: ${colors.body};
	margin: 0 0 24px;
	&:last-child {
		margin-bottom: 0;
	}
	strong {
		color: ${colors.navy};
		font-weight: 600;
	}
	${MOBILE} {
		font-size: 16px;
		line-height: 2;
		margin-bottom: 16px;
	}
`
